import React from "react";
import AddOneOneLegacy from "./AddOneOne";
import AddOneOneNew from "./AppointmentScheduler";

const SchedulerWrapper = (props: any) => {
  if (props.offCanvasComp === "newAppointmentV2") {
    return <AddOneOneNew {...props} />;
  }
  return <AddOneOneLegacy {...props} />;
};

export default SchedulerWrapper;
